<div class="wrapper">
  <div class="feature-type-selector">
    <radio
      [options]="featureTypeOptions"
      [value]="selectedFeatureType"
      name="featureType"
      [controlled]="true"
      (onChange)="onFeatureTypeChange($event)"
    ></radio>
  </div>
  <map-coordinates-finder
    *ngIf="isCoordinatesPopupVisible"
    (onClose)="isCoordinatesPopupVisible = false"
    [map]="map"
  ></map-coordinates-finder>
  <div id="ol-map" class="ol-map"></div>
  <div #olPopup class="ol-popup" [ngClass]="{ 'is-open': isPopupVisible }">
    <a href="#" class="ol-popup-closer"></a>
    <div class="ol-popup-content">
      <ng-container *ngIf="popupData.id">
        {{ 'PROPERY_CODE' | translate }}:
        <a [routerLink]="['/properties', popupData.id]">{{
          popupData.property_code
        }}</a>
      </ng-container>
      <ng-container *ngIf="popupData.licenses">
        <strong>{{ 'LICENSES' | translate }}</strong>
        <div *ngFor="let license of popupData.licenses">
          <a [routerLink]="['/licenses', license.id]">{{ license.code }}</a>
        </div>
      </ng-container>
    </div>
  </div>
</div>
